const ReplyIcon = ({ 
    width = 12, 
    height = 13, 
    fill = "#0F172A", 
    className, 
    ...props 
}) => (
    <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M6.975 12.2063C6.825 12.0563 6.75 11.8813 6.75 11.6813C6.75 11.4813 6.825 11.3063 6.975 11.1562L9.13125 9H2.25C1.8375 9 1.48437 8.85313 1.19062 8.55938C0.896875 8.26562 0.75 7.9125 0.75 7.5V0.75C0.75 0.5375 0.821875 0.359375 0.965625 0.215625C1.10937 0.071875 1.2875 0 1.5 0C1.7125 0 1.89062 0.071875 2.03437 0.215625C2.17812 0.359375 2.25 0.5375 2.25 0.75V7.5H9.13125L6.95625 5.325C6.80625 5.175 6.73437 5 6.74062 4.8C6.74687 4.6 6.81875 4.425 6.95625 4.275C7.10625 4.125 7.28125 4.04688 7.48125 4.04063C7.68125 4.03438 7.85625 4.10625 8.00625 4.25625L11.475 7.725C11.55 7.8 11.6031 7.88125 11.6344 7.96875C11.6656 8.05625 11.6812 8.15 11.6812 8.25C11.6812 8.35 11.6656 8.44375 11.6344 8.53125C11.6031 8.61875 11.55 8.7 11.475 8.775L8.04375 12.2063C7.89375 12.3563 7.71562 12.4313 7.50937 12.4313C7.30312 12.4313 7.125 12.3563 6.975 12.2063Z"
            fill={fill}
        />
    </svg>
);

export default ReplyIcon;
